var config = {
  requestUrl: 'https://gatewayapi.cqliving.com',
  imgCode: 'https://captcha.cqliving.com'
  // imgCode: 'http://121.199.78.162:31789'
};
export default config;